import React from "react";
import {recordHandledError} from "../services/errorReporting";

export default class AppErrorBoundary extends React.Component {
  state = {failed: false};

  static getDerivedStateFromError() {
    return {failed: true};
  }

  componentDidCatch(error) {
    recordHandledError(error, "website.render", {kind: "render"});
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main role="alert" style={{maxWidth: 640, margin: "4rem auto", padding: "1.5rem"}}>
        <h1>Something went wrong</h1>
        <p>This page could not load. Please try again.</p>
        <button type="button" onClick={() => this.setState({failed: false})}>
          Try again
        </button>
        <p>If the problem continues, contact support@duffloo.com.</p>
      </main>
    );
  }
}
